// hooks/useTableColumns.ts
import { useCallback, useState } from "react";

export const useTableColumns = (type: 'tasks' | 'invoicing' = 'tasks') => {
  // Common base columns without ET (since it needs different positioning)
  const commonBaseColumns = [
    { key: "serial", label: "#", sortable: false, visible: true, width: "30px", minWidth: "30px" },
    { key: "client", label: "CLIENT", sortable: true, visible: true, width: "125px", minWidth: "125px" },
    { key: "task", label: "TASK", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "subTask", label: "SUB-TASK", sortable: true, visible: true, width: "125px", minWidth: "125px" },
    { key: "allottedTo", label: "ALLOTTED TO", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "teamLeader", label: "TEAM LEADER", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "priority", label: "PRIORITY", sortable: true, visible: true, width: "90px", minWidth: "90px" },
    { key: "dueDate", label: "DUE DATE", sortable: true, visible: true, width: "120px", minWidth: "120px" },
    { key: "frequency", label: "FREQUENCY", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "status", label: "STATUS", sortable: true, visible: true, minWidth: "120px", width: "120px" },
    { key: "tt", label: "TT", sortable: true, visible: true, width: "80px", minWidth: "80px", hideOnMobile: false },
  ];

  // Task-specific columns with ET in the correct position
  const taskColumns = [
    { key: "serial", label: "#", sortable: false, visible: true, width: "30px", minWidth: "30px" },
    { key: "client", label: "CLIENT", sortable: true, visible: true, width: "125px", minWidth: "125px" },
    { key: "task", label: "TASK", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "subTask", label: "SUB-TASK", sortable: true, visible: true, width: "125px", minWidth: "125px" },
    { key: "et", label: "ET", sortable: true, visible: true, width: "60px", minWidth: "60px", hideOnMobile: false },
    { key: "allottedTo", label: "ALLOTTED TO", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "teamLeader", label: "TEAM LEADER", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "priority", label: "PRIORITY", sortable: true, visible: true, width: "90px", minWidth: "90px" },
    { key: "dueDate", label: "DUE DATE", sortable: true, visible: true, width: "120px", minWidth: "120px" },
    { key: "frequency", label: "FREQUENCY", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "status", label: "STATUS", sortable: true, visible: true, minWidth: "120px", width: "120px" },
    { key: "tt", label: "TT", sortable: true, visible: true, width: "60px", minWidth: "60px", hideOnMobile: false },
    { key: "actions", label: "", visible: true, width: "120px", minWidth: "120px" }
  ];

  // Invoicing-specific columns with Amount before Actions
  const invoicingColumns = [
    { key: "serial", label: "#", sortable: false, visible: true, width: "30px", minWidth: "30px" },
    { key: "client", label: "CLIENT", sortable: true, visible: true, width: "125px", minWidth: "125px" },
    { key: "task", label: "TASK", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "subTask", label: "SUB-TASK", sortable: true, visible: true, width: "125px", minWidth: "125px" },
    { key: "allottedTo", label: "ALLOTTED TO", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "teamLeader", label: "TEAM LEADER", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "priority", label: "PRIORITY", sortable: true, visible: true, width: "90px", minWidth: "90px" },
    { key: "dueDate", label: "DUE DATE", sortable: true, visible: true, width: "120px", minWidth: "120px" },
    { key: "frequency", label: "FREQUENCY", sortable: true, visible: true, width: "125px", minWidth: "125px", hideOnMobile: false },
    { key: "status", label: "STATUS", sortable: true, visible: true, minWidth: "120px", width: "120px" },
    { key: "tt", label: "TT", sortable: true, visible: true, width: "60px", minWidth: "60px", hideOnMobile: false },
    { key: "amount", label: "AMOUNT", sortable: true, visible: true, minWidth: "100px", width: "100px" },
    { key: "actions", label: "ACTIONS", visible: true, width: "150px", minWidth: "150px" },
  ];

  const getInitialColumns = () => {
    if (type === 'invoicing') {
      return invoicingColumns;
    }
    return taskColumns;
  };

  const [columns, setColumns] = useState(getInitialColumns());

  const handleColumnChange = useCallback((selectedKeys: string[]) => {
    setColumns((prev) =>
      prev.map((col) => ({
        ...col,
        visible: selectedKeys.includes(col.key),
      }))
    );
  }, []);

  return {
    columns,
    setColumns,
    handleColumnChange,
  };
};